import React from 'react';
import { Spin, Empty } from 'antd';

import { InfoItem, SortableList } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { useRulesByIds } from '@api/hooks';
import { useMap } from '@hooks';

import RuleForm from '../RuleForm';

const extractContent = (html) => new DOMParser().parseFromString(html, 'text/html').documentElement.textContent;

const RulesList = ({ value, onChange, parentSectionId, locale }) => {
  const [rules, setRules] = React.useState([]);
  const { isFetching } = useRulesByIds(
    { ids: value?.map(({ id }) => id), locale, withFallback: true },
    { onSuccess: (_rules) => setRules(_rules) },
  );

  const handleOnChange = (_rules) => {
    // optimistic update
    setRules(_rules);
    onChange(_rules);
  };

  return (
    <Spin spinning={isFetching}>
      {rules.length > 0 ? (
        <SortableList style={NO_MARGIN_BOTTOM} value={rules} onChange={handleOnChange} useEditable={useMap}>
          {(rule, { edit, isEdit }) =>
            isEdit ? (
              <RuleForm
                parentSectionId={parentSectionId}
                ruleId={rule.id}
                onClose={edit}
                editing={isEdit}
                locale={rule.language}
              />
            ) : (
              <InfoItem onClick={edit}>{extractContent(rule.text)}</InfoItem>
            )
          }
        </SortableList>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Spin>
  );
};

export default RulesList;
